import type { SelectedStore } from "@components/try-and-buy/types/store";
import { REASON } from "../constants";

export const getReason = ({
    sku,
    selectedStore,
    hasStoresWithAvailability,
}: {
    sku?: string;
    selectedStore: SelectedStore | null;
    hasStoresWithAvailability: boolean;
}) => {
    if (!sku) {
        return REASON.variant;
    }
    if (!hasStoresWithAvailability) {
        return REASON.noStores;
    }
    if (!selectedStore) {
        return REASON.store;
    }

    return REASON.escape;
};
